import { render, staticRenderFns } from "./LatestPriceModal.vue?vue&type=template&id=95a58134&scoped=true&"
import script from "./LatestPriceModal.vue?vue&type=script&lang=js&"
export * from "./LatestPriceModal.vue?vue&type=script&lang=js&"
import style0 from "./LatestPriceModal.vue?vue&type=style&index=0&id=95a58134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a58134",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDataTable})
